import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "plus-small, add small" }, [
      _createElementVNode("rect", {
        width: "20",
        height: "20",
        rx: "10",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        id: "vector",
        d: "M9.9974 5.41406V9.9974M9.9974 9.9974V14.5807M9.9974 9.9974H5.41406M9.9974 9.9974H14.5807",
        stroke: "#8E8E93",
        "stroke-linecap": "round"
      })
    ], -1)
  ])))
}
export default { render: render }